(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artical-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('article-social-share')) {
    customElements.define(
      'article-social-share',
      class ArticleSocialShare extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.shareButton = this.querySelector('[data-native-share]');
          this.copyButton = this.querySelector('[data-copy-link]');
          this.status = this.querySelector('[data-share-status]');

          this.shareButton.addEventListener('click', () => this.share());
          this.copyButton.addEventListener('click', () => this.copy());
        }

        async share() {
          try {
            if (navigator.share) {
              await navigator.share({
                title: this.dataset.shareTitle,
                url: this.dataset.shareUrl,
              });

              return;
            }

            await this.copy();
          } catch (error) {
            if (error.name !== 'AbortError') {
              await this.copy();
            }
          }
        }

        async copy() {
          try {
            await navigator.clipboard.writeText(this.dataset.shareUrl);
            this.announce(this.dataset.copySuccess);
          } catch (error) {
            this.announce(this.dataset.copyError);
          }
        }

        announce(message) {
          this.status.textContent = '';

          requestAnimationFrame(() => {
            this.status.textContent = message;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer-collections"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('drawer-collections')) {
    customElements.define(
      'drawer-collections',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          const tabs = [...this.querySelectorAll('[role="tab"]')];
          const panels = [...this.querySelectorAll('[role="tabpanel"]')];
          const activate = (index) => {
            tabs.forEach((tab, i) => {
              tab.setAttribute('aria-selected', String(i === index));
              tab.tabIndex = i === index ? 0 : -1;
              panels[i].hidden = i !== index;
            });
            requestAnimationFrame(() => panels[index].querySelector('items-carousel')?.scheduleLayout?.());
          };
          tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => activate(index));
            tab.addEventListener('keydown', (event) => {
              let next;
              if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
              if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = tabs.length - 1;
              if (next === undefined) return;
              event.preventDefault();
              event.stopPropagation();
              activate(next);
              tabs[next].focus();
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["megam-mobile-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('megam-collapse')) {
    customElements.define(
      'megam-collapse',
      class extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector(':scope > .megam_mobile-row > button');
          this.panel = this.querySelector(':scope > .megam_mobile-children');
          if (!this.trigger || !this.panel) return;
          this.onToggle = () => this.setOpen(this.panel.hidden);
          this.onKeydown = (event) => {
            if (event.key !== 'Escape' || this.panel.hidden) return;
            event.preventDefault();
            event.stopPropagation();
            this.escapeHandled = true;
            this.setOpen(false);
            this.trigger.focus();
          };
          this.onKeyup = (event) => {
            if (event.key !== 'Escape' || !this.escapeHandled) return;
            this.escapeHandled = false;
            event.stopPropagation();
          };
          this.trigger.addEventListener('click', this.onToggle);
          this.addEventListener('keydown', this.onKeydown);
          this.addEventListener('keyup', this.onKeyup);
        }
        setOpen(open) {
          this.panel.hidden = !open;
          this.trigger.setAttribute('aria-expanded', String(open));
        }
        disconnectedCallback() {
          this.trigger?.removeEventListener('click', this.onToggle);
          this.removeEventListener('keydown', this.onKeydown);
          this.removeEventListener('keyup', this.onKeyup);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["var-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-color-swatches')) {
    customElements.define('card-color-swatches', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelectorAll('[data-fallback-color]').forEach((swatch) => {
          const color = swatch.dataset.fallbackColor;
          if (CSS.supports('color', color)) {
            swatch.style.setProperty('--swatch-bg', color);
          }
        });
        this.addEventListener('click', async (event) => {
          const button = event.target.closest('.card-color-swatches__swatch');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          this.querySelectorAll('.card-color-swatches__swatch').forEach((swatch) => {
            swatch.setAttribute('aria-pressed', String(swatch === button));
          });
          const card = this.closest('prodct-card-in');
          const carousel = card?.querySelector('.card-variant-carousel');
          if (carousel) {
            this.dispatchEvent(new CustomEvent('card:select-image', {
              bubbles: true,
              detail: { imageId: button.dataset.imageId }
            }));
            return;
          }
          const image = card?.querySelector('.card__media img');
          if (!image || !button.dataset.image) return;
          const request = (this.imageRequest || 0) + 1;
          this.imageRequest = request;
          this.imageAnimation?.cancel();
          const source = button.dataset.image;
          if (image.getAttribute('src') === source) return;
          const preview = new Image();
          const loaded = await new Promise((resolve) => {
            preview.onload = () => resolve(true);
            preview.onerror = () => resolve(false);
            preview.src = source;
          });
          if (!loaded || request !== this.imageRequest || !this.isConnected) return;
          const animate = typeof image.animate === 'function' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (animate) {
            this.imageAnimation = image.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, easing: 'ease-out', fill: 'forwards' });
            await this.imageAnimation.finished.catch(() => {});
            if (request !== this.imageRequest || !this.isConnected) return;
          }
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = source;
          image.alt = button.dataset.imageAlt || '';
          image.width = Number(button.dataset.imageWidth);
          image.height = Number(button.dataset.imageHeight);
          card.classList.add('card--color-selected');
          this.imageAnimation?.cancel();
          if (animate) {
            this.imageAnimation = image.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: 'ease-in' });
          }
        });
      }
      disconnectedCallback() {
        this.imageRequest = (this.imageRequest || 0) + 1;
        this.imageAnimation?.cancel();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
